<div [attr.tabindex]="sortable() ? 0 : null" [attr.role]="sortable() ? 'button' : null">
  <div><ng-content></ng-content></div>
  @if (sortable()) {
    <sb-icon
      class="text-subtle transition-transform"
      [ngClass]="{ '-rotate-180': direction() === 'asc', 'opacity-0': !sorted() }"
      [size]="'lg'"
      [name]="'arrow-down-regular'"
    />
  }
</div>
